module.exports = __webpack_public_path__ + "img/back_4.27f22dba.jpg";